import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import config from 'config/default.json';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';

@Component({
  selector: 'app-vcl-create-project',
  templateUrl: './vcl-create-project.component.html',
  styleUrls: ['./vcl-create-project.component.scss']
})
export class VcCreateProjectComponent{
  constructor(
    private elRef:ElementRef,
    public cdRef: ChangeDetectorRef,
    private apiService: ApiServiceModule,
    private sharedService: SharedService) {
  }
  @Input() userInfos: { [x:string]: any } = new Map();
  filterData:any = [];
  pageId = 'vcl-create-project'
  modes:{ [x:string]: string|number }[] = [];// [{id:1, key: 'raw', value: 'Raw'}, {id: 2, key: 'splited', value: 'Split'}];
  dataSource:{[x: string]: any}[] = [];
  platformInfos:{[x: string]: any} = {origin: 'virtualclass', key: 'vcl', root: 'VIRTUALCLASS'}

  ngOnInit(): void {

  }
  setProgress(data:any){

  }
  sendFilterData(filterData:any){
    this.filterData = filterData;
  }
}
